// React component for the live tracking indicator

import React from 'react';
import { Equipment } from '../../redux/api/equipment/equipment.model';
import { ReactComponent as LiveTrackingIcon } from '../../assets/live-tracking-indicator.svg';
import TwTooltip from '../TwTooltip/TwTooltip';
import Box from '@mui/material/Box';
import { TRIP_STATUS } from '../../redux/api/trips/trips.model';
import { ORDER_STATUS } from '../../redux/api/orders/orders.model';

export const LiveTrackingOrderIndicator = ({
  orderStatus,
  equipment
}: {
  orderStatus?: ORDER_STATUS;
  equipment?: Equipment | null;
}): JSX.Element => {
  return (
    <>
      {equipment && equipment?.asset_eld_id && equipment.eld_connection_id && orderStatus && (
        <Box marginLeft="8px" alignItems="center" sx={{ display: 'flex' }}>
          <TwTooltip
            title={
              orderStatus === ORDER_STATUS.IN_TRANSIT
                ? 'Order has live tracking'
                : `Live tracking unavailable: Order ${
                    [ORDER_STATUS.NOT_STARTED].includes(orderStatus) ? 'not started' : 'delivered'
                  }`
            }
            placement="top"
          >
            <LiveTrackingIcon
              stroke={orderStatus === ORDER_STATUS.IN_TRANSIT ? '#2A4DD0' : '#9CA3AF'}
            />
          </TwTooltip>
        </Box>
      )}
    </>
  );
};

export const LiveTrackingTripIndicator = ({
  tripStatus,
  equipment
}: {
  tripStatus?: TRIP_STATUS;
  equipment?: Equipment | null;
}): JSX.Element => {
  return (
    <>
      {equipment && equipment?.asset_eld_id && equipment.eld_connection_id && tripStatus && (
        <Box marginLeft="8px" alignItems="center" sx={{ display: 'flex' }}>
          <TwTooltip
            title={
              tripStatus === TRIP_STATUS.IN_TRANSIT
                ? 'Trip has live tracking'
                : `Trip tracking unavailable: Trip ${
                    tripStatus === TRIP_STATUS.DRAFT ? 'not started' : 'delivered'
                  }`
            }
            placement="top"
          >
            <LiveTrackingIcon
              stroke={tripStatus === TRIP_STATUS.IN_TRANSIT ? '#2A4DD0' : '#9CA3AF'}
            />
          </TwTooltip>
        </Box>
      )}
    </>
  );
};
